// extracted by mini-css-extract-plugin
module.exports = {"burger":"Header_burger__b4Tnu"};